module.exports = __webpack_public_path__ + "img/chloraseptic_max_strength_sore_throat_lozenges.943fd99e.png";